import { useContext } from 'react';

import { logger } from '@packages/utilities';

import { TrackingContext } from '../../components/TrackingProvider';

export const useIsBot = (): boolean => {
  const context = useContext(TrackingContext);

  if (context === null) {
    logger.error('[useTracking]: hook use outside TrackingProvider component.');
    return false;
  }

  const { isBot } = context;

  return isBot;
};
